import { Typography } from "@hellocarbo/lasagne";

type ComparisonDatabaseValueProps = {
  title: string;
  value: string;
};

function ComparisonDatabaseValue({
  title,
  value,
}: ComparisonDatabaseValueProps) {
  return (
    <div className="border-grayscale-xx-light p-sm flex flex-col items-center justify-center rounded-md border">
      <Typography step="-1" className="mb-3xs text-grayscale">
        {title}
      </Typography>
      <Typography step="2" as="span" className="text-center">
        {value}
      </Typography>
    </div>
  );
}

export default ComparisonDatabaseValue;
